module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n    <p>Classification Category was Successfully Added</p>\r\n</div>"